import { Title } from 'react-admin';
import { Box } from '@mui/material';
import { IndexingStats } from '../components/IndexingStats';

export const Dashboard = () => (
	<Box>
		<Title title="Dashboard" />
		<IndexingStats />
	</Box>
);

export default Dashboard;